import React from 'react';
import './faq.css'
import pic24 from '../../assets/pic24.png'
import { useState } from 'react';


const FAQss = (props) => {

        const [open, setOpen] = useState(false);

    return ( 

        <article className='faqbox'>
            <article className='subbox-faqs'>
                <h2 className='question'>{props.title}</h2>
                <figure className='img-container-sec4'>
                    <img src={pic24} alt='add' className='add-imgggg'
                     onClick={() => setOpen(!open)} ></img>
                </figure>
            </article>
                        {open && (
                <p className='answer'>
                    {props.parag}
                </p>
            )}
            <div className='line-faqs'></div>
        </article>

     );
}
 
export default FAQss;